export default __webpack_public_path__ + "static/media/ekene.0b572151.png";